<template>
  <div @mouseleave="onMouseLeave" @mouseover="onMouseOver">
    <clouded-glass class="device">
      <div slot="content">
        <div class="main">
          <el-row style="width: 100%;height: 20px;padding-top: 8px;text-align: right">
            <el-col :span="24" class="btn-content">
              <img @touchstart.stop="edit" @click.stop="edit" alt="编辑" class="hidden btn btn-edit" ref="btnEdit"
                   src="@/assets/images/icon/edit.png"
                   v-show="showBtn">
              <img @touchstart.stop="deleteById" @click.stop="deleteById" alt="删除" class="hidden btn btn-delete" ref="btnDelete"
                   src="@/assets/images/icon/delete.png"
                   v-show="showBtn">
            </el-col>
          </el-row>
          <el-row style="margin-top:20px;height: 30px;width: 100%">
            <span class="name">{{ data.deviceName ? data.deviceName : '未知' }}</span>
          </el-row>
          <div class="line cross-line"></div>
          <el-row>
            <el-col :span="4">
              测点:
            </el-col>
            <el-col :span="16" style="text-align: left;margin-left: 20px;overflow-y:auto;height: 200px;">
              <div v-if="!data.alternateDevicePointList || data.alternateDevicePointList==''">
                暂无数据
              </div>
              <div :key="item.id" v-for="item in data.alternateDevicePointList">
                {{ item.pointName }}
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </clouded-glass>
  </div>
</template>

<script>
import CloudedGlass from "@/components/style/CloudedGlass";

export default {
  name: "alternate_device_detail",
  props: ["data"],
  components: {CloudedGlass},
  data() {
    return {
      showBtn: false
    }
  },
  methods: {
    onMouseOver() {
      this.showBtn = true
    },
    onMouseLeave() {
      this.showBtn = false
    },
    edit() {
      console.log("=====");
      this.$emit("edit", this.data)
    },
    deleteById() {
      this.$confirm('是否确认删除', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            this.$emit("deleteById", this.data.id)
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.main {
  width: 178px;
  overflow: auto;
  margin: 30px 46px 10px 31px;
  text-align: center;
}

.cross-line {
  width: 100%;
  margin: 10px 0 16px 0;
  /*border: 1px solid #299BFF;*/
  border-bottom: 1px solid rgba(41, 155, 255, 0.2);
  opacity: 0.5;
}

.name {
  width: 60px;
  height: 20px;
  font-size: 1.06rem;
  font-weight: bold;
  line-height: 20px;
  color: #299BFF;
  opacity: 1;
}

.point {
  text-align: left;
}

.device {
  margin: 10px 10px 10px 5px;
  width: 240px;
  height: 338px;
  background: rgba(0, 0, 0, 0);
}
</style>
